import { Component, OnInit } from '@angular/core';
import {UserService} from "../../service/user.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.css']
})
export class DestinationsComponent implements OnInit {
  dest: any;
  showNavigationIndicators = false;
  constructor(private userService:UserService,private route:Router) { }

  ngOnInit(): void {
    this.getallDesti();
  }

  getallDesti(){
    this.userService.getallDesti().subscribe(
        res=>{
          this.dest=res.data;
        }
    )
  }

  booking(d: any) {
    localStorage.setItem('desti',JSON.stringify(d));
    this.route.navigate(['/destination-detail']);
  }
}
